import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyFamily: BaseKeyFunction = () => ["family"];
